// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"y_sX h_jr h_fq h_ft h_fF h_dM h_z","menuItemSub":"y_sY h_dT h_fq h_fF","menuMainLink":"y_sZ h_js h_hl","menuLink":"y_s0 h_js h_hl","Link":"y_rx q_rx q_qP q_q7"};